module.exports = __webpack_public_path__ + "img/GENERAL-S-CROSS-1.818f9f08.jpg";